var $19d166403b390914$exports = {};
$19d166403b390914$exports = {
    "clear": `T\xf8m`,
    "invalid": `(ugyldig)`,
    "loading": `Laster inn ...`,
    "noResults": `Ingen resultater`,
    "valid": `(gyldig)`
};


export {$19d166403b390914$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
